import intersection from "./intersection/index";
import line from "./line/index";
import { point, copyPoints } from "./point/index";
import quaternion from "./quarternion/index";
import range from "./range/index";
import vector from "./vector/index";
import coordinate from "./coordinate/index";
import Plane from "./plane/index";
import MathRect from "./rectangle/index";
import Basic from "./basic/index";

import {
  calculateTransform,
  Transform,
  getTransform,
  Projection
} from "./transform/index";

function degToRad(degrees) {
  const degreeToRadiansFactor = Math.PI / 180;

  return degrees * degreeToRadiansFactor;
}

function radToDeg(radians) {
  const radianToDegreesFactor = 180 / Math.PI;

  return radians * radianToDegreesFactor;
}

function min(...values) {
  return Math.min(...values);
}

function max(...values) {
  return Math.max(...values);
}

function abs(value) {
  return Math.abs(value);
}

// Returns sign of number
function sign(x) {
  return typeof x === "number"
    ? x
      ? x < 0
        ? -1
        : 1
      : // eslint-disable-next-line no-self-compare
      x === x
      ? 0
      : NaN
    : NaN;
}

function roundToDecimal(value, precision) {
  const multiplier = Math.pow(10, precision);

  return Math.round(value * multiplier) / multiplier;
}
const math = {
  degToRad,
  radToDeg,
  sign,
  roundToDecimal,
  intersection,
  coordinate,
  line,
  point,
  copyPoints,
  quaternion,
  range,
  min,
  max,
  abs,
  vector,
  Plane,
  MathRect,
  calculateTransform,
  Transform,
  getTransform,
  Projection,
  Basic
};

export default math;
